var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCoursePsm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.6,
    height: 15.799,
    viewBox: "0 0 43.6 15.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "psm",
    transform: "translate(0 -12.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4334",
    "data-name": "Group 4334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6160",
    "data-name": "Path 6160",
    d: "M0,28.5V12.9H5.7a11.153,11.153,0,0,1,2.7.3,4.333,4.333,0,0,1,2,1.1,3.766,3.766,0,0,1,.9,1.5,6.648,6.648,0,0,1,.3,2.1,5.558,5.558,0,0,1-.4,2.3A5.444,5.444,0,0,1,10.1,22a2.577,2.577,0,0,1-1.3.8,5.255,5.255,0,0,1-2,.3H2.2v5.3H0Zm2.2-7.2H7.4a1.949,1.949,0,0,0,.8-.1,1,1,0,0,0,.5-.4,2.261,2.261,0,0,0,.6-1.3,8.807,8.807,0,0,0,.2-1.7,3.174,3.174,0,0,0-.7-2.3,3.1,3.1,0,0,0-1.3-.6,8.969,8.969,0,0,0-1.8-.2H2.2Z",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4335",
    "data-name": "Group 4335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6161",
    "data-name": "Path 6161",
    d: "M13.6,27.1l.5-1.3,1.5.4a16.247,16.247,0,0,0,1.9.4,9.852,9.852,0,0,0,1.7.2,4.023,4.023,0,0,0,2.6-.7,2.384,2.384,0,0,0,.9-2,2.769,2.769,0,0,0-.1-.9,1.794,1.794,0,0,0-.5-.7,3.49,3.49,0,0,0-.9-.6,9.75,9.75,0,0,0-1.4-.6L18,20.7a17.076,17.076,0,0,1-1.8-.7,7.3,7.3,0,0,1-1.3-.9,2.836,2.836,0,0,1-.8-1.1,3.194,3.194,0,0,1-.3-1.4,3.287,3.287,0,0,1,.4-1.7,4.263,4.263,0,0,1,1.1-1.2,4.842,4.842,0,0,1,1.8-.7,7.845,7.845,0,0,1,2.2-.2,19.419,19.419,0,0,1,2.4.2,16.817,16.817,0,0,1,2.4.7l-.4,1.4-1.4-.2c-.5-.1-1.1-.1-1.6-.2-.5,0-1-.1-1.4-.1a6.163,6.163,0,0,0-2.6.4,1.551,1.551,0,0,0-.9,1.5,1.483,1.483,0,0,0,.1.7,2.651,2.651,0,0,0,.5.6,1.934,1.934,0,0,0,.9.5,10.865,10.865,0,0,0,1.4.5l1.7.6c.7.3,1.3.5,1.9.8.5.3,1,.6,1.4.9a4.184,4.184,0,0,1,.8,1.2,4.309,4.309,0,0,1,.3,1.7,4.058,4.058,0,0,1-.4,1.9,4.177,4.177,0,0,1-1.1,1.5,5.076,5.076,0,0,1-1.8.9,8.524,8.524,0,0,1-2.3.3,7.569,7.569,0,0,1-1.5-.1l-1.5-.3a5.782,5.782,0,0,1-1.4-.5A2.281,2.281,0,0,1,13.6,27.1Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6162",
    "data-name": "Path 6162",
    d: "M27.6,28.5V12.9h1.9c.1,0,.1.1.2.2l6,7.6h0l5.9-7.6.2-.2c.1,0,.2-.1.3-.1h1.5V28.4H41.5V16.2h0a6.125,6.125,0,0,1-.4.6,5.547,5.547,0,0,0-.6.8c-.2.3-.4.5-.6.8s-.4.5-.6.8l-3,3.8H35.1a.367.367,0,0,1-.3-.1c-.1,0-.1-.1-.2-.2l-2.9-3.6c-.2-.2-.4-.5-.6-.7-.2-.3-.4-.5-.6-.8s-.4-.5-.5-.7a2.092,2.092,0,0,1-.4-.6h0V28.6h-2Z",
    fill: "#525252"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoursePsm);
export default __webpack_public_path__ + "static/media/icon_course_psm.941c1cad2e1f27172a3a3d17a0fa3298.svg";
export { ForwardRef as ReactComponent };